const ALTERNATIVES_ATTRIBUTES_ORDER = [
  "Color - #E9D590 - Gold",
  "Color - #D9D9D9 - Silver",
  "Color - #E9D590/#D9D9D9 - Gold/Silver",
  "Color - #E9D590/#FFFFFF - Pave",
  "Color - #FDFCF7/#233C95 - Marble Blue",
  "Color - #ffffff - White",
  "Color - #0D145B - Blue",
  "Color - #7AA762 - Green",
  "Color - #FFFFFF - White Ceramic",
  "Color - #C60258 - Rubine Pink",
  "Color - #830E0D - Red Garnet",
  "Color - #20209C - Blue",
  "Color - #0D145B - Oxford Blue",
  "Color - #000000 - Black",
  "Color - #8ECD34 - Bright Green",
  "Color - #FFFFFF - Diamond",
  "Color - #01694A - Emerald",
  "Color - #E9D590/#FFFFFF - Gold/White Ceramic",
  "Color - #E9D590/#FFFFFF - Gold/Clear",
  "Color - #E9D590/#000000 - Gold/Black",
  "Color - #E9D590/#498F6D - Gold/Green",
  "Color - #E9D590/#FDFCF7 - Gold/Pearl",
  "Color - #990101 - Red Garnet",
  "Color - #7D4A87 - Amethyst",
  "Color - #CEE0E4 - Aquamarine",
  "Color - #FDFCF7 - Pearl",
  "Color - #AD1457 - Ruby",
  "Color - #7D844D - Peridot",
  "Color - #141059 - Blue Sapphire",
  "Color - #F4F0EA - Opal",
  "Color - #EECA72 - Citrine",
  "Color - #69BBDD - Blue Topaz",
  "Color - #AABB75 - Green Sapphire",
  "Color - #FFFFFF - White Sapphire",
  "Color - #D9D9D9/#7096FE - Silver/Blue",
  "Color - #D9D9D9/#FDFCF7 - Silver/Pearl",
  "Color - #D9D9D9/#000000 - Silver/Black Ceramic",
  "Color - #D9D9D9/#FFFFFF - Pave Silver",
  "Color - #00795A - Green Onyx",
  "Color - #D9D9D9/#E9D590 - Links",
  "Color - #D9D9D9/#FFFFFF - Silver Pave",
  "Color - #E9D590/#FFFFFF - Gold Pave",
  "Color - #E9D590/##D9D9D9/#FFFFFF - Two Tone Pave",
  "Color - #4D6243 - Jade",
  "Color - #141059 - Navy",
  "Color - #FDFCF7 - White Enamel",
  "Color - #FDFCF7 - Mother of Pearl",
  "Color - #F0CDCB - Rose Quartz",
  "Color - #4BCF99 - Green Sapphire",
  "Color - #F0CDCB - Light Pink Sapphire",
  "Color - #990101 - January (Red Garnet)",
  "Color - #7D4A87 - February (Amethyst)",
  "Color - #CEE0E4 - March (Aquamarine)",
  "Color - #FFFFFF - April (Diamond)",
  "Color - #01694A - May (Emerald)",
  "Color - #FDFCF7 - June (Pearl)",
  "Color - #8F7096 - June (Alexandrite)",
  "Color - #AD1457 - July (Ruby)",
  "Color - #7D844D - August (Peridot)",
  "Color - #141059 - September (Blue Sapphire)",
  "Color - #F4F0EA - October (Opal)",
  "Color - #C96772 - October (Pink Tourmaline)",
  "Color - #EECA72 - November (Citrine)",
  "Color - #69BBDD - December (Blue Topaz)",
  "Color - #FFFFFF - Full Pave Gold",
  "Color - #69BBDD - Blue",
  "Color - #F0CDCB - Pink",
  "Color - #8E393D - Red",
];

export default ALTERNATIVES_ATTRIBUTES_ORDER;
